export default {
  momentLocale: 'es',
  Timeline: {
    expand: 'Expandir',
    fold: 'Ocultar',
  },
  Balloon: {
    close: 'Cerrar',
    confirm: 'Aceptar',
    cancel: 'Cancelar',
  },
  Card: {
    expand: 'Expandir',
    fold: 'Ocultar',
  },
  Calendar: {
    today: 'Hoy',
    now: 'Este momento',
    ok: 'Confirmar',
    clear: 'Limpiar',
    month: 'Mes',
    year: 'año',
    prevYear: 'Año pasado',
    nextYear: 'próximo año',
    prevMonth: 'Mes Pasado',
    nextMonth: 'Próximo mes',
    prevDecade: 'Doce Años Anteriores',
    nextDecade: 'Después de doce años',
    yearSelectAriaLabel: 'Seleccionar año',
    monthSelectAriaLabel: 'Seleccionar mes',
    format: {
      months: '1 mes_2 mes_3 mes_4 mes_5 mes_6 mes_7 mes_8 mes_9 mes_10 mes_11 mes_12 mes'.split(
        '_',
      ),
      shortMonths: '1 mes_2 mes_3 mes_4 mes_5 mes_6 mes_7 mes_8 mes_9 mes_10 mes_11 mes_12 mes'.split(
        '_',
      ),
      weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
      shortWeekdays: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
      veryShortWeekdays: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb'.split('_'),
      yearLabel: 'YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Por favor, seleccione una fecha',
    datetimePlaceholder: 'Por favor, seleccione la fecha y hora',
    monthPlaceholder: 'Por favor, seleccione un mes',
    yearPlaceholder: 'Por favor, seleccione el año',
    now: 'Ahora',
    selectTime: 'Seleccionar hora',
    selectDate: 'Seleccionar fecha',
    ok: 'Confirmar',
    clear: 'Limpiar',
    startPlaceholder: 'Fecha de inicio',
    endPlaceholder: 'Fecha de finalización',
    hour: 'Hora',
    minute: 'minuto',
    second: 'segundo',
  },
  Dialog: {
    close: 'Cerrar',
    ok: 'Confirmar',
    cancel: 'Cancelar',
  },
  Message: {
    closeAriaLabel: 'Cerrar',
  },
  Pagination: {
    goTo: 'Ir a',
    page: 'Página',
    total: 'Página {current}, de {total}',
    labelPrev: 'Página anterior, página actual {current}',
    labelNext: 'Siguiente página, página actual {current}',
    inputAriaLabel: 'Ingrese el número de página al que desea saltar',
    selectAriaLabel: 'Selecciona cuántas entradas mostrar por página',
    pageSize: 'Elementos/Página',
  },
  Input: {
    clear: 'Limpiar',
  },
  Select: {
    selectPlaceholder: 'Por favor, selecciona',
    autoCompletePlaceholder: 'Ingrese',
    notFoundContent: 'Sin opciones',
    maxTagPlaceholder: '{selected}/{total} elementos seleccionados',
  },
  Table: {
    empty: 'No hay datos',
    ok: 'Confirmar',
    reset: 'Reiniciar',
    asc: 'Ascendente',
    desc: 'Descendente',
    expanded: 'Expandido',
    folded: 'Colapsado',
    filter: 'Filtrar',
    selectAll: 'Seleccionar todo',
  },
  TimePicker: {
    placeholder: 'Por favor, seleccione la hora',
    startPlaceholder: 'Hora de inicio',
    endPlaceholder: 'Hora de finalización',
    clear: 'Limpiar',
    hour: 'hora',
    minute: 'min',
    second: 'segundo',
  },
  Transfer: {
    items: 'elementos',
    item: 'elemento',
    moveAll: 'Mover todo',
    searchPlaceholder: 'Por favor, ingresa',
    moveToLeft: 'Deseleccionar elemento',
    moveToRight: 'Enviar elementos seleccionados',
  },
  Upload: {
    card: {
      cancel: 'Cancelar',
      addPhoto: 'Subir imagen',
      download: 'Descargar',
      delete: 'Eliminar',
    },
    drag: {
      text: 'Haz clic o arrastra los archivos al área de líneas punteadas para subir',
      hint: 'Compatible con archivos de tipo docx, xls, PDF, rar, zip, PNG, JPG, entre otros',
    },
    upload: {
      delete: 'Eliminar',
    },
  },
  Search: {
    buttonText: 'Buscar',
  },
  Tag: {
    delete: 'Eliminar',
  },
  Rating: {
    description: 'Opciones de calificación',
  },
};
